export const RoleNames = [
    // Internal users:
    "ADMIN",
    "IMPERSONATOR",
    "ADMIN_PANEL_ACCESSOR",
    "EMPLOYEE",
    "DEV",
    "SUPERVISOR",
    "ILLUSIONIST",
    "ACCOUNT_MANAGER",
    "TRANSLATION_MANAGER",
    "PAYMENT_COORDINATOR",
    "SHIPMENT_CONTACT",
    "CHANNEL_PARTNER",
    "EQUIPMENT_RENTAL_PARTNER",
    "COMMODITY_PURCHASE_PARTNER",
    "INPUT_PURCHASE_PARTNER",
    "OUTPUT_SUPPLIER",
    "FIELD_SUPERVISOR",
    "FIELD_AGENT",
    "EXECUTIVE",
    "EQUIPMENT_MANAGER",
    "EQUIPMENT_RENTER",
    "EQUIPMENT_BUYER",
    "EQUIPMENT_OPERATOR",
    // Markeplace roles
    "MARKETPLACE_ITEM_EDITOR",
    "MARKETPLACE_ORDER_EDITOR",
    "MARKETPLACE_BUYER",
    // Scraper bot role
    "SCRAPER_BOT",
    // Content management roles:
    "PROFILE_VIEWER",
    "PROFILE_EDITOR",
    "ORDER_VIEWER",
    "ORDER_EDITOR",
    "FEED_EDITOR",
    "LOCATION_EDITOR",
    "REWARD_EDITOR",
    "CATALOG_EDITOR",
    "INSURANCE_POLICY_EDITOR",
    "QUALITY_CHECKER",
    "SOIL_TESTING_ADMIN",
    "TESTER",
    // App users:
    "OUTPUT_BUYER",
    "OUTPUT_SELLER",
    // Registration status:
    "REGISTERED",
    "GUEST",
    // Entities:
    "OWNER",
    "VIEWER",
    "EDITOR",
];
export const Roles = Object.fromEntries(RoleNames.map(_ => [_, _]));
export const TargetTypeNames = [
    "System",
    "CollectionCenter",
    "Cluster",
];
export const PayoutApprovalRanks = {
    FINANCE_TEAM: 1,
    EMP: 2,
    CP: 4,
};
//# sourceMappingURL=roles.js.map